import { useCallback,useMemo } from 'react';
import { useMemberPortalApi } from './memberPortalApiClient';
export function useMemberAcademyApi() {
  const {memberPortalApiGet,memberPortalApiPost}=useMemberPortalApi();
  const get=useCallback(async(club,path)=>{
    const res=await memberPortalApiGet(`/api/members-portal/${encodeURIComponent(club)}/academy/${path}`);const payload=await res.json();
    if(!res.ok||payload.ok===false)throw new Error(payload.error||'server_error');return payload.data;
  },[memberPortalApiGet]);
  const post=useCallback(async(club,action,payload,key)=>{
    const res=await memberPortalApiPost(`/api/members-portal/${encodeURIComponent(club)}/academy/${action}`,payload,{headers:{'Idempotency-Key':key}});const data=await res.json();
    if(!res.ok||data.ok===false)throw new Error(data.error||'server_error');return data.data;
  },[memberPortalApiPost]);
  return useMemo(()=>({get,post}),[get,post]);
}
